// extracted by mini-css-extract-plugin
export var barContainer = "_60-0";
export var extraThin = "_60-3";
export var fillBar = "_60-6";
export var fillContainer = "_60-4";
export var overflow = "_60-8";
export var overflowContainer = "_60-5";
export var regular = "_60-7";
export var thick = "_60-1";
export var thin = "_60-2";